import React from "react"
import PropTypes from "prop-types"

import locale from "@irati/utils/locale"
import {Para} from "@irati/ui/src/Labels"

import {Warning} from "../Layout"
import {
  tzAwareMoment,
  isNextTriggerAtInThePast,
  isStartAtAfterNextTriggerAt,
  isStartAtInThePast
} from "../../helpers/schedule"
import {NextTriggerAtSummary} from "./"


const StartAtWarning = ({schedule}) => {
  /** If there isn't a startAt field don't continue */
  if (!schedule.startAt) return null

  /** Ensure that the default time is set (servers default isn't necessarily this) */
  const startAtTzAware = tzAwareMoment(schedule, "startAt")

  const startAtIsInThePast = isStartAtInThePast(schedule)

  /** Don't show a warning if the startAt property is further in the future than the nextTriggerAt property */
  if (!startAtIsInThePast && isStartAtAfterNextTriggerAt(schedule)) return null

  /** Is the startAt or nextTriggerAt in the past? */
  if (startAtIsInThePast || isNextTriggerAtInThePast(schedule)) {
    return (
      <Warning>
        <Para>
          The date your next pulse survey is due to go out
          (<strong>{startAtTzAware.format(locale.dates.longFormat)}</strong>) is in the past.
        </Para>

        <Para>Please amend this by selecting a new survey start date before resuming the schedule.</Para>
      </Warning>
    )
  }


  /** Next trigger at warning */
  if (schedule.lastTriggeredAt) {
    return (
      <Warning>
        <NextTriggerAtSummary schedule={schedule} />
        <Para>If you wish to change this, select a different survey start date above.</Para>
      </Warning>
    )
  }

  /** Otherwise render nothing */
  return null
}

StartAtWarning.propTypes = {
  schedule: PropTypes.object
}

StartAtWarning.defaultProps = {
  schedule: {}
}

export default StartAtWarning
